import * as React from 'react';
import CourtReporting939DataCore from '../CourtReporting/CourtReporting939DataCore';
import { UserRoleEnum } from '../../redux/UserSlice';



const CourtReporting939JAP = (props: any) => {
    return (
        <React.Fragment>
            <CourtReporting939DataCore userRole={UserRoleEnum.EntityUser} dataSection={"JuvenileAlternativeProgram"} />
        </React.Fragment>
    );
}

export default CourtReporting939JAP;